import React from 'react';
import LoginForm from './LoginForm';

function Login() {
  return (
    <div className="bg-login-background bg-cover">
      <LoginForm />
    </div>
  );
}

export default Login;
